export default "__VITE_ASSET__BogBHOVr__"